"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontFamilies = void 0;
exports.fontFamilies = {
    common: "Inter, sans-serif",
    title: "'Playfair Display', sans-serif;"
};
